/**
 * Shared utility for building share URLs.
 * Centralizes URL construction to ensure consistency across environments.
 */

/**
 * Build a share URL for a given token.
 * Uses VITE_APP_URL env var if available, otherwise falls back to window.location.origin.
 * This ensures share links work correctly across staging, production, and preview deployments.
 */
export function buildShareUrl(token: string): string {
  const baseUrl = import.meta.env.VITE_APP_URL || window.location.origin;
  return `${baseUrl}/share/${token}`;
}
